// Formato compartido por los detalles de pago (PaymentModal / PaymentOrderModal).
export default {
  methods: {
    money(value) {
      const number = Number(value) || 0;
      const sign = number < 0 ? "−" : "";
      return `${sign}$${Math.abs(number).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    },
    // Sin valor (null / "") devuelve null para que el campo muestre "—"
    optionalMoney(value) {
      if (value === null || value === undefined || value === "") return null;
      return this.money(value);
    },
    // Respuestas crudas (JSON del procesador): se muestran plegadas
    isLongText(value) {
      return String(value || "").length > 60;
    },
    prettyText(value) {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    },
    orderRoute(orderNumber) {
      return { name: "OrdersPage", query: { orderOpen: orderNumber } };
    }
  }
};
